import { ReactNode } from "react";
import { Container } from "@/components/common/Container";
import { AnimatedHeading } from "@/components/common/AnimatedHeading";
import { Reveal } from "@/components/common/Reveal";
import { cn } from "@/lib/utils";

interface PageHeroProps {
  eyebrow: string;
  titleLines: string[];
  description?: ReactNode;
  children?: ReactNode;
  className?: string;
  actions?: ReactNode;  //added by sudip
}

/** Reusable inner-page hero header with the kinetic masked-title reveal. */
export function PageHero({
  eyebrow,
  titleLines,
  description,
  children,
  className,
  actions
}: PageHeroProps) {
  return (
    <section
      className={cn(
        "relative overflow-hidden pb-12 pt-24 lg:pb-16 lg:pt-28",
        className,
      )}
    >
      <div className=" absolute inset-0 overflow-hidden pointer-events-none">

        <div className="absolute left-0 top-0 h-80 w-80 rounded-full bg-primary/10 blur-[120px]"/>

        <div className="absolute right-0 bottom-0 h-96 w-96 rounded-full bg-cyan-400/10 blur-[140px]"/>
      </div>
      {/* Ambient background wash */}
      {/* <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-40 left-1/2 h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-primary/[0.07] blur-[120px]" />
        <div className="absolute inset-0 bg-grid opacity-[0.5]" />
      </div> */}

      <Container>
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.14em] text-primary">
            <span className="h-1.5 w-1.5 rounded-full bg-accent" />
            {eyebrow}
          </span>
        </Reveal>

        <AnimatedHeading
          lines={titleLines}
          className="mt-6 max-w-4xl font-heading text-4xl font-bold leading-[1.1] tracking-tight text-foreground lg:text-5xl"
          // className="mt-6 max-w-4xl font-heading text-4xl font-bold leading-[1.1] tracking-tight text-foreground sm:text-5xl lg:text-6xl"
        />

        {description && (
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-2xl text-lg text-muted-foreground">
              {description}
            </p>
          </Reveal>
        )}

        {/* added by sudip */}
        {actions && (

          <Reveal delay={0.2}>

              <div className="mt-8">

                  {actions}

              </div>

          </Reveal>

        )}

        {children && (
          <Reveal delay={0.2}>
            <div className="mt-10">{children}</div>
          </Reveal>
        )}
      </Container>
      <div className="mx-auto mt-12 max-w-7xl">
        <div className="h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      </div>
    </section>
  );
}
